export const getExpiryYear = (expiry = '') => {
    return expiry.split('/')[1] ? '20' + expiry.split('/')[1] : null;
};
export const getExpiryMonth = (expiry = '') => {
    return expiry.split('/')[0] || null;
};
